import { useState } from 'react';

import type Paginated from '../../core/paginable';
import { useGetApplication } from '../../hooks';

import { type Penalty } from './types';

export const useGetPenaltiesTypes = () => {
  const [state] = useState<any>({});
  const result = useGetApplication<Array<{ id: string; name: string }>>({
    url: `Penalties/penaltiesTypes`,
    params: state,
    headers: {
      lang: true
    }
  });
  return result;
};

export const useGetValuePenaltiesTypes = () => {
  const [state] = useState<any>({});
  const result = useGetApplication<Array<{ id: string; name: string }>>({
    url: `Penalties/valuePenaltiesTypes`,
    params: state,
    headers: {
      lang: true
    }
  });
  return result;
};

export const useGetPenaltyById = (id: string) => {
  const [{ data, loading, error }] = useGetApplication<Paginated<Penalty>>({
    url: 'Penalties',
    params: { page: 1, pageSize: 1, id: id }
  });

  const [penalty] = data?.data || [];
  return { loading, error, penalty };
};
